import { API_PUBLIC_BASE } from './supabase/info';

export type FunnelEvent = 'open_auth' | 'start_signup';

type TrackOptions = {
  oncePerSessionDay?: boolean;
};

function todayKey(): string {
  return new Date().toISOString().slice(0, 10);
}

export function trackFunnelEvent(event: FunnelEvent, options: TrackOptions = {}): void {
  const { oncePerSessionDay = true } = options;
  const sessionKey = `talentfunn_funnel_${event}_${todayKey()}`;

  try {
    if (oncePerSessionDay && typeof sessionStorage !== 'undefined' && sessionStorage.getItem(sessionKey) === '1') {
      return;
    }

    fetch(`${API_PUBLIC_BASE}/funnel-event`, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event }),
    })
      .then(() => {
        if (oncePerSessionDay && typeof sessionStorage !== 'undefined') {
          sessionStorage.setItem(sessionKey, '1');
        }
      })
      .catch(() => {});
  } catch {
    // ignore funnel tracking errors
  }
}
